import { RESET_POSTS } from '../actions/actionsAppTest'
import {
  RECEIVE_POSTS_SIMU_ACCESSORIES, REQUEST_POSTS_SIMU_ACCESSORIES, REJECT_POSTS_SIMU_ACCESSORIES,
  REQUEST_POSTS_SIMU_VEHICLE_DETAILS, RECEIVE_POSTS_SIMU_VEHICLE_DETAILS, REJECT_POSTS_SIMU_VEHICLE_DETAILS,
  REQUEST_POSTS_SIMU_VEHICLES, RECEIVE_POSTS_SIMU_VEHICLES, REJECT_POSTS_SIMU_VEHICLES,
  REQUEST_POSTS_SIMU_OPTIONS, RECEIVE_POSTS_SIMU_OPTIONS, REJECT_POSTS_SIMU_OPTIONS
} from '../actions/actionsApiSimulation';
import { REQUEST_POSTS_FINANCEFILE, RECEIVE_POSTS_FINANCEFILE, REJECT_POSTS_FINANCEFILE } from '../actions/actionsApiFinanceFile'
import {
  REQUEST_POSTS_VERSION, RECEIVE_POSTS_VERSION, REJECT_POSTS_VERSION,
  REQUEST_POSTS_ROUTINGINFO, RECEIVE_POSTS_ROUTINGINFO, REJECT_POSTS_ROUTINGINFO
} from '../actions/actionsApi'
import {
  REQUEST_POSTS_CRITERIA, RECEIVE_POSTS_CRITERIA, REJECT_POSTS_CRITERIA,
  REQUEST_POSTS_SVCLEVELS, RECEIVE_POSTS_SVCLEVELS, REJECT_POSTS_SVCLEVELS,
  REQUEST_POSTS_OFFERS, RECEIVE_POSTS_OFFERS, REJECT_POSTS_OFFERS
} from '../actions/actionsApiOffer'

export const initialPostsContext = {
  isFetchingSimulation: false, hasFetchedSimulation: false,
  isFetchingSimulationOption: false, isFetchingSimulationAccessories: false, isFetchingSimulationVehicles: false,
  isFetchingOffers: false, isFetchingFinanceFile: false, isFetchingCriteria: false, isFetchingServiceLevels: false
};

export function posts(state, action) {
  switch (action.type) {
    case REQUEST_POSTS_SIMU_VEHICLE_DETAILS:
      return { ...state, isFetchingSimulation: true };
    case RECEIVE_POSTS_SIMU_VEHICLE_DETAILS:
    case REJECT_POSTS_SIMU_VEHICLE_DETAILS:
      return { ...state, isFetchingSimulation: false, hasFetchedSimulation: true };
    case REQUEST_POSTS_FINANCEFILE:
      return { ...state, isFetchingFinanceFile: true };
    case RECEIVE_POSTS_FINANCEFILE:
    case REJECT_POSTS_FINANCEFILE:
      return { ...state, isFetchingFinanceFile: false };
    case REQUEST_POSTS_SIMU_OPTIONS:
      return { ...state, isFetchingSimulationOption: true };
    case RECEIVE_POSTS_SIMU_OPTIONS:
    case REJECT_POSTS_SIMU_OPTIONS:
      return { ...state, isFetchingSimulationOption: false };
    case REQUEST_POSTS_SIMU_ACCESSORIES:
      return { ...state, isFetchingSimulationAccessories: true };
    case RECEIVE_POSTS_SIMU_ACCESSORIES:
    case REJECT_POSTS_SIMU_ACCESSORIES:
      return { ...state, isFetchingSimulationAccessories: false };
    case REQUEST_POSTS_SIMU_VEHICLES:
      return { ...state, isFetchingSimulationVehicles: true };
    case RECEIVE_POSTS_SIMU_VEHICLES:
    case REJECT_POSTS_SIMU_VEHICLES:
      return { ...state, isFetchingSimulationVehicles: false };
    case REQUEST_POSTS_OFFERS:
      return { ...state, isFetchingOffers: true };
    case RECEIVE_POSTS_OFFERS:
    case REJECT_POSTS_OFFERS:
      return { ...state, isFetchingOffers: false };
    case REQUEST_POSTS_CRITERIA:
      return { ...state, isFetchingCriteria: true };
    case RECEIVE_POSTS_CRITERIA:
    case REJECT_POSTS_CRITERIA:
      return { ...state, isFetchingCriteria: false };
    case REQUEST_POSTS_SVCLEVELS:
      return { ...state, isFetchingServiceLevels: true };
    case RECEIVE_POSTS_SVCLEVELS:
    case REJECT_POSTS_SVCLEVELS:
      return { ...state, isFetchingServiceLevels: false };
    case REQUEST_POSTS_VERSION:
    case RECEIVE_POSTS_VERSION:
    case REJECT_POSTS_VERSION:
    case REQUEST_POSTS_ROUTINGINFO:
    case RECEIVE_POSTS_ROUTINGINFO:
    case REJECT_POSTS_ROUTINGINFO:
    case RESET_POSTS:
      return {
        ...state, isFetchingSimulation: false,
        isFetchingSimulationOption: false, isFetchingSimulationAccessories: false, isFetchingSimulationVehicles: false,
        isFetchingOffers: false, isFetchingFinanceFile: false
      };
    default:
      return state
  }
}
